<div class="org-unit-tree-select">
  @if (label) {
    <span class="org-unit-tree-select__label">{{ label }}</span>
  }
  <p-treeselect class="org-unit-tree-select__control"
                [class.org-unit-tree-select__control--labeled]="!!label"
                [options]="treeOptions"
                [ngModel]="selectedNode"
                (ngModelChange)="onSelectionChange($event)"
                selectionMode="single"
                [filter]="true"
                filterBy="label"
                [filterPlaceholder]="searchPlaceholder || placeholder"
                [placeholder]="placeholder"
                [ariaLabel]="label || placeholder"
                [disabled]="disabled"
                [fluid]="true"
                [showClear]="true"
                [appendTo]="'body'"
                [overlayOptions]="{ styleClass: overlayRootClass }"
                scrollHeight="20rem"
                [panelStyleClass]="overlayPanelClass">
  </p-treeselect>
</div>
